import { IQuoteSection } from 'types/quote'
import InfoArea from './InfoArea'

const Fifth = ({ quoteInfo }: IQuoteSection) => {
    return (
        <div className='bg-white border-[#9D9EB7] border-1 rounded-lg'>
            <div className='bg-[#F8F8FA] px-10 py-6 rounded-t-lg'>
                <p className='font-semibold first-line:text-2xl'>기타 부가 정보</p>
            </div>

            <div className='flex flex-col gap-6 px-10 py-6'>
                <InfoArea
                    title='희망 출항일'
                    value={
                        quoteInfo.step3?.preferredDepartureDate ?
                            quoteInfo.step3?.preferredDepartureDate :
                            '없음'
                    }
                />
                <InfoArea
                    title='희망 입항일'
                    value={
                        quoteInfo.step3?.preferredArrivalDate ?
                            quoteInfo.step3?.preferredArrivalDate :
                            '없음'
                    }
                />
                <InfoArea
                    title='타겟운임'
                    value={
                        quoteInfo.step3?.targetFreight > 0 ?
                            `${quoteInfo.step3?.currency ?? ''} ${quoteInfo.step3?.targetFreight.toLocaleString()}` :
                            '없음'
                    }
                />
                <InfoArea
                    title='타겟 선적지 프리타임'
                    value={
                        quoteInfo.step3?.isOriginDnd ?
                            `Demurrage ${quoteInfo.step3?.originDemurrage} / Detention ${quoteInfo.step3?.originDetention}` :
                            '아니오'
                    }
                />
                <InfoArea
                    title='타겟 도착지 프리타임'
                    value={
                        quoteInfo.step3?.isDestinationDnd ?
                            `Demurrage ${quoteInfo.step3?.destinationDemurrage} / Detention ${quoteInfo.step3?.destinationDetention}` :
                            '아니오'
                    }
                />
                <InfoArea
                    title='통관 대행 여부'
                    value={quoteInfo.step3?.clearanceRequired ? '예' : '아니오'}
                />
                <InfoArea
                    title='보험 대행 여부'
                    value={quoteInfo.step3?.insuranceREquired ? '예' : '아니오'}
                />
            </div>
        </div >
    )
}

export default Fifth